import Vue from "vue";
import {
  Icon,
  Popup,
} from "vant";
Vue.use(Icon);
Vue.use(Popup);



// WEBPACK FOOTER //
// ./src/assets/javascript/vant.js